import { useState } from "react";
import translator from "../../i18n";

const settingsKey = "user.settings";

export interface IUserSettings {
	lang: string | null;
	company: string;
}

const defaultSettings: IUserSettings = {
	lang: null,
	company: "",
};

export function useSettings() {
	const storedSettings = localStorage.getItem(settingsKey);
	const currentSettings = storedSettings
		? JSON.parse(storedSettings)
		: defaultSettings;
	const [settings, setSettings] = useState<IUserSettings>(currentSettings);

	const updateSettings = (newSettings) => {
		setSettings(newSettings);
		translator.changeLanguage(newSettings.lang);
		localStorage.setItem(settingsKey, JSON.stringify(newSettings));
	};

	return { settings, updateSettings };
}
